const accordionEls  = document.querySelectorAll(`[lsg-accordion-item]`),
      debug         = true;

accordionEls.forEach((accordionEl) => {

    const btnEl         = accordionEl.querySelector(`[lsg-accordion-item-btn]`),
          contentEl     = accordionEl.querySelector(`[lsg-accordion-item-content]`);
    
    // Init
    const radioEl = accordionEl.querySelector(`input[type="radio"]`);

    if (radioEl) {
        if (!radioEl.checked == true) {
            accordionEl.setAttribute(`aria-expanded`, false);
            collapseSection(contentEl);
        }
    } else {
        accordionEl.setAttribute(`aria-expanded`, false);
        collapseSection(contentEl);
    }

    btnEl.addEventListener(`click`, e => {
        if (debug) console.log(`[LSG] Accordion button clicked.`);
        if (contentEl && contentEl.getAttribute(`lsg-transitioning`) !== 'true') {
            const expanded      = accordionEl.getAttribute(`aria-expanded`),
                  parentEl      = accordionEl.parentElement,
                  accordionEls  = parentEl.querySelectorAll(`[lsg-accordion-item]`);
            
            // Close others
            accordionEls.forEach((otherEl) => {
                if (otherEl !== accordionEl && otherEl.getAttribute(`aria-expanded`) === 'true') {
                    const contentEl = otherEl.querySelector(`[lsg-accordion-item-content]`);
                    otherEl.setAttribute(`aria-expanded`, false);
                    collapseSection(contentEl);
                }
            });

            if (expanded === 'true') {
                accordionEl.setAttribute(`aria-expanded`, false);
                collapseSection(contentEl);
            } else {
                accordionEl.setAttribute(`aria-expanded`, true);
                expandSection(contentEl);
            }
        } else {
            // Close others
            accordionEls.forEach((otherEl) => {
                if (otherEl !== accordionEl && otherEl.getAttribute(`aria-expanded`) === 'true') {
                    const contentEl = otherEl.querySelector(`[lsg-accordion-item-content]`);
                    otherEl.setAttribute(`aria-expanded`, false);
                    collapseSection(contentEl);
                }
            });
        }
    });

});

function collapseSection(element) {
    if (element && element.getAttribute(`lsg-transitioning`) !== 'true') {
        element.setAttribute(`lsg-transitioning`, true);

        // get the height of the element's inner content, regardless of its actual size
        let sectionHeight = element.scrollHeight;

        if (debug) console.log(`[LSG] Collapsing item, sectionHeight:`, sectionHeight);
        
        // temporarily disable all css transitions
        let elementTransition           = element.style.transition;
            element.style.transition    = '';
        
        // on the next frame (as soon as the previous style change has taken effect),
        // explicitly set the element's height to its current pixel height, so we 
        // aren't transitioning out of 'auto'
        requestAnimationFrame(function() {
            element.style.height = sectionHeight + 'px';
            element.style.transition = elementTransition;
            
            // on the next frame (as soon as the previous style change has taken effect),
            // have the element transition to height: 0
            requestAnimationFrame(function() {
                element.style.height = 0 + 'px';
                element.setAttribute(`lsg-transitioning`, false);
                if (debug) console.log(`[LSG] Transition complete.`);
            });
        });
        
    }
}
  
function expandSection(element) {
    if (element && element.getAttribute(`lsg-transitioning`) !== 'true') {
        element.setAttribute(`lsg-transitioning`, true);

        // get the height of the element's inner content, regardless of its actual size
        let sectionHeight = element.scrollHeight;

        if (debug) console.log(`[LSG] Expanding item, sectionHeight:`, sectionHeight);
        
        // have the element transition to the height of its inner content
        element.style.height = sectionHeight + 'px';

        let transitionFunc = function(e) {

            // remove this event listener so it only gets triggered once
            element.removeEventListener('transitionend', transitionFunc);
            
            // remove "height" from the element's inline styles, so it can return to its initial value
            element.style.height = null;

            // check new height
            let newHeight = element.scrollHeight;
            if (debug) console.log(`[LSG] Transition complete, newHeight:`, newHeight);

            // done transitioning
            element.setAttribute(`lsg-transitioning`, false);
        }

        // when the next css transition finishes (which should be the one we just triggered)
        element.addEventListener('transitionend', transitionFunc);

    }
}